// Tipos para el árbol de preguntas

export interface QuestionTreeMetadata {
  carrier: string;
  market: string;
  version: number;
  locale: string;
}

export interface QuestionOption {
  value: string;
  label: string;
}

// Regla simple de visibilidad
export interface SimpleVisibilityRule {
  field: string;
  operator: "=" | "!=" | ">" | "<" | ">=" | "<=" | "contains" | "not_contains";
  value: string;
  source?: "lead" | "custom";
}

// Grupo de reglas anidadas con su propia lógica
export interface NestedVisibilityRule {
  logic: "AND" | "OR";
  rules: VisibilityRuleItem[];
}

// Una regla puede ser simple o un grupo anidado
export type VisibilityRuleItem = SimpleVisibilityRule | NestedVisibilityRule;

// Helper para verificar si es una regla anidada
export const isNestedRule = (rule: VisibilityRuleItem): rule is NestedVisibilityRule => {
  return "logic" in rule && "rules" in rule;
};

// Visibilidad puede tener el formato nuevo (con rules) o el formato legacy (field, operator, value directamente)
export interface QuestionVisibility {
  logic: "AND" | "OR";
  rules?: VisibilityRuleItem[];
  // Formato legacy: cuando no hay rules, estos campos están directamente en visibility
  field?: string;
  operator?: "=" | "!=" | ">" | "<" | ">=" | "<=" | "contains" | "not_contains";
  value?: string;
  source?: "lead" | "custom";
}

export type QuestionType =
  | "radio"
  | "boolean_question"
  | "calendar_extended"
  | "number"
  | "select_multiple"
  | "select_button"
  | "checkbox"
  | "checkbox_optional"
  | "checkbox_mandatory"
  | "text";

export interface Question {
  id: number;
  name: string;
  type: QuestionType;
  content: string;
  field: string;
  required: boolean;
  subtitle?: string;
  tooltip?: string;
  product_type: string;
  component_name?: string;
  options?: QuestionOption[];
  visibility?: QuestionVisibility;
  limit_options?: number;
}

export interface Answer {
  question_id: number;
  value: string;
  label: string | string[] | null;
}

// Datos del lead que pueden usarse en reglas de visibilidad
export type LeadData = Record<string, string | number | boolean>;

export interface QuestionTreeResponse {
  metadata: QuestionTreeMetadata;
  questions: Question[];
  answers: Answer[];
  lead?: LeadData;
}

// Estado interno para manejar las respuestas
export type AnswersMap = Record<string, string>;

// Pregunta con estado de respuesta
export interface QuestionWithAnswer extends Question {
  answer?: string;
  answerLabel?: string;
}
